"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NoMatchContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _peractoUi = require("@peracto/peracto-ui");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var NoMatchContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n    height: 100vh;\n\n    p {\n        font-size: 1.1rem;\n    }\n"])));

exports.NoMatchContainer = NoMatchContainer;

var NoMatchRoute = function NoMatchRoute() {
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    render: function render() {
      return /*#__PURE__*/_react["default"].createElement(_peractoUi.NotFoundMessage, null);
    }
  }));
};

var _default = NoMatchRoute;
exports["default"] = _default;